const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
  },
  iconContainer: {
    backgroundColor: '#1084AC',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fileIcon: {
    color: 'white',
    fontSize: '20px',
  },
  documentInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  openIcon: {
    color: '#666',
    fontSize: '16px',
  },
})

export default styles
